import React, { useCallback, useEffect, useContext, } from 'react'
import useReactRouter from 'use-react-router'
import { getRedirectQueryParamFromLocation, } from '@shapr/react-shared/utils/queryParam'
import ChildrenTypes from '@shapr/react-shared/types/Children'
import appendQuery from 'append-query'

import GlobalContext from '~/contexts/GlobalContext'
import localStorageConfig from '~/config/localStorageConfig'
import redirectConfig from '~/config/redirect'

const StorageLogic = props => {
  const { children, } = props
  const { history, location, } = useReactRouter()
  const { setGlobalContext, } = useContext(GlobalContext)

  const handleStorage = useCallback(
    e => {
      if (e.key === localStorageConfig.authToken)
        if (
          !e.newValue &&
          location.pathname !== '/login' &&
          location.pathname !== '/login/'
        ) {
          setGlobalContext({ authToken: undefined, })
          history.replace(
            appendQuery(
              '/login',
              getRedirectQueryParamFromLocation({
                location,
                defaultRedirect: redirectConfig.default,
              }),
            ),
          )
        } else if (
          e.newValue &&
          (location.pathname === '/login' || location.pathname === '/login/')
        ) {
          setGlobalContext({ authToken: e.newValue, })
        }
    },
    [location.pathname,],
  )
  useEffect(() => {
    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [handleStorage,])

  return children || null
}

StorageLogic.propTypes = {
  children: ChildrenTypes,
}

export default React.memo(StorageLogic)
